import _slicedToArray from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { OktaAuth } from '@okta/okta-auth-js';
import Emitter from 'eventemitter3';
var defaultScopes = ['profile openid email'];
var defaultConfig = {
  qa: {
    issuer: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7' // issuer: 'https://api.aegis.nikecloud.com/v1/qa',
    // authorizeUrl: 'https://api.aegis.nikecloud.com/v1/qa/authorize',
    // tokenUrl: 'https://api.aegis.nikecloud.com/v1/qa/token',

  },
  prod: {
    issuer: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7' // issuer: 'https://api.aegis.nikecloud.com/v1/prod',
    //   authorizeUrl: 'https://api.aegis.nikecloud.com/v1/prod/authorize',
    //   tokenUrl: 'https://api.aegis.nikecloud.com/v1/prod/token',

  }
};

function httpRequestClient(_x, _x2, _x3) {
  return _httpRequestClient.apply(this, arguments);
}

function _httpRequestClient() {
  _httpRequestClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(method, url, args) {
    var fetchParams, response, json;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            fetchParams = _objectSpread({
              method: method
            }, args);

            if (url.includes('.well-known/openid-configuration') || url.includes('token')) {
              delete fetchParams.credentials;
              delete fetchParams.headers['X-Okta-User-Agent-Extended'];
            }

            if (args.data) {
              fetchParams.body = args.data;
              delete fetchParams.data;
            }

            _context7.next = 5;
            return fetch(url, fetchParams);

          case 5:
            response = _context7.sent;
            _context7.next = 8;
            return response.json();

          case 8:
            json = _context7.sent;
            return _context7.abrupt("return", {
              responseText: json
            });

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _httpRequestClient.apply(this, arguments);
}

var events = ['login:expired', 'login:error', 'login:success', 'logout:success', 'renew:access:success', 'renew:id:success', 'renew:error'];
var pendingPromise = new Promise(function (resolve) {});

var AegisClient = /*#__PURE__*/function () {
  function AegisClient(_ref) {
    var _this = this;

    var clientId = _ref.clientId,
        redirectUri = _ref.redirectUri,
        _ref$qa = _ref.qa,
        qa = _ref$qa === void 0 ? false : _ref$qa,
        _ref$disableTokenStor = _ref.disableTokenStorage,
        disableTokenStorage = _ref$disableTokenStor === void 0 ? false : _ref$disableTokenStor,
        _ref$pkce = _ref.pkce,
        pkce = _ref$pkce === void 0 ? true : _ref$pkce,
        responseType = _ref.responseType,
        _ref$scopes = _ref.scopes,
        scopes = _ref$scopes === void 0 ? defaultScopes : _ref$scopes,
        config = _ref.config;

    _classCallCheck(this, AegisClient);

    var environmentConfig = config || qa ? defaultConfig.qa : defaultConfig.prod;
    this._okta = new OktaAuth({
      clientId: clientId,
      redirectUri: redirectUri,
      responseType: responseType,
      pkce: pkce,
      httpRequestClient: httpRequestClient,
      issuer: environmentConfig.issuer,
      tokenManager: {
        storage: disableTokenStorage ? 'memory' : 'sessionStorage'
      }
    });
    this._events = new Emitter();
    this._scopes = scopes;

    this._okta.tokenManager.on('error', function () {
      var _this$_events;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_this$_events = _this._events).emit.apply(_this$_events, ['renew:error'].concat(args));
    });

    this._okta.tokenManager.on('renewed', function (type) {
      var _this$_events2, _this$_events3;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      switch (type) {
        case 'accessToken':
          return (_this$_events2 = _this._events).emit.apply(_this$_events2, ['renew:access:success'].concat(args));

        case 'idToken':
          return (_this$_events3 = _this._events).emit.apply(_this$_events3, ['renew:id:success'].concat(args));
      }
    });

    this._okta.tokenManager.on('expired', function () {
      var _this$_events4;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return (_this$_events4 = _this._events).emit.apply(_this$_events4, ['login:expired'].concat(args));
    });
  }

  _createClass(AegisClient, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var authorizeOptions,
            isAuthenticated,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                authorizeOptions = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};

                if (!this._okta.isLoginRedirect()) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return this._okta.handleLoginRedirect();

              case 4:
                return _context.abrupt("return", this.finalizeLogin());

              case 5:
                _context.next = 7;
                return this._okta.isAuthenticated();

              case 7:
                isAuthenticated = _context.sent;

                if (!isAuthenticated) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", this.finalizeLogin());

              case 10:
                return _context.abrupt("return", this.login(authorizeOptions));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var authorizeOptions,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                authorizeOptions = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                _context2.prev = 1;
                _context2.next = 4;
                return this._okta.signInWithRedirect(_objectSpread({
                  scopes: this._scopes
                }, authorizeOptions));

              case 4:
                _context2.next = 6;
                return pendingPromise;

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                this._events.emit('login:error', _context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function login() {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._okta.tokenManager.clear();

                this._events.emit('logout:success');

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this._okta.tokenManager.get('accessToken'));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAccessToken() {
        return _getAccessToken.apply(this, arguments);
      }

      return getAccessToken;
    }()
  }, {
    key: "getIdToken",
    value: function () {
      var _getIdToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this._okta.tokenManager.get('idToken'));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getIdToken() {
        return _getIdToken.apply(this, arguments);
      }

      return getIdToken;
    }()
  }, {
    key: "on",
    value: function on(event, handler) {
      validateEvent(event);

      this._events.on(event, handler);
    }
  }, {
    key: "once",
    value: function once(event, handler) {
      validateEvent(event);

      this._events.once(event, handler);
    }
  }, {
    key: "off",
    value: function off(event, handler) {
      validateEvent(event);

      this._events.off(event, handler);
    }
  }, {
    key: "finalizeLogin",
    value: function () {
      var _finalizeLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _yield$Promise$all, _yield$Promise$all2, accessToken, idToken;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Promise.all([this.getAccessToken(), this.getIdToken()]);

              case 2:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                accessToken = _yield$Promise$all2[0];
                idToken = _yield$Promise$all2[1];

                this._events.emit('login:success', {
                  accessToken: accessToken,
                  idToken: idToken
                });

                return _context6.abrupt("return", {
                  accessToken: accessToken,
                  idToken: idToken
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function finalizeLogin() {
        return _finalizeLogin.apply(this, arguments);
      }

      return finalizeLogin;
    }()
  }]);

  return AegisClient;
}();

function validateEvent(event) {
  if (!events.includes(event)) throw new Error("event must be one of: ".concat(events.join(', ')));
}

export { AegisClient };